var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c(
            "div",
            { attrs: { id: "customToolbar" } },
            [
              _c(
                "c-switch",
                _vm._b(
                  {
                    attrs: { id: "isAclEnabled", color: "primary", label: "" },
                    model: {
                      value: _vm.isAclEnabled,
                      callback: function ($$v) {
                        _vm.isAclEnabled = $$v
                      },
                      expression: "isAclEnabled",
                    },
                  },
                  "c-switch",
                  _vm.labelIcon,
                  false
                )
              ),
              _vm._v(_vm._s(_vm.$t("admin.enable_acl")) + "\n    "),
            ],
            1
          ),
          _c("bootstrap-table", {
            ref: "table",
            attrs: {
              columns: _vm.columns,
              data: _vm.data,
              options: _vm.options,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }